import PropTypes from 'prop-types';

export const CompanyLogoSkeleton = ({ className, size }) => (
  <div className={`generic-company-logo ${size} ${className} animate-flicker`} />
);

CompanyLogoSkeleton.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(['xsmall', 'small', 'xmedium', 'medium', 'large', '']),
};

CompanyLogoSkeleton.defaultProps = {
  className: '',
  size: '',
};
